export const translateSeed = (seedString: string): number =>
  Number(BigInt(seedString) % BigInt(Number.MAX_SAFE_INTEGER));
